// Define as cores baseadas no nome do estágio
export const getStageColor = (stage) => {
  if (!stage) return 'bg-gray-100 text-gray-700';
  if (stage.includes('Cold') || stage.includes('0.0')) return 'bg-gray-100 text-gray-700';
  if (stage.includes('Identificar') || stage.includes('1.')) return 'bg-blue-100 text-blue-700';
  if (stage.includes('Prospectar') || stage.includes('Contactado') || stage.includes('2.')) return 'bg-yellow-100 text-yellow-700';
  if (stage.includes('Oferta') || stage.includes('Análise') || stage.includes('Proposta') || stage.includes('3.')) return 'bg-orange-100 text-orange-700';
  if (stage.includes('Negociação') || stage.includes('Aceita') || stage.includes('4.0')) return 'bg-purple-100 text-purple-700';
  if (stage.includes('Fechamento')) return 'bg-green-100 text-green-700';
  if (stage.includes('Descartada') || stage.includes('7.')) return 'bg-red-100 text-red-700';
  if (stage.includes('Do Not') || stage.includes('9.0') || stage.includes('8.')) return 'bg-slate-200 text-slate-700';
  return 'bg-gray-100 text-gray-700';
};

// Lista estática de colaboradores para o dropdown de filtro
export const colaboradores = [
  { id: 'all', value: 'all', nome: 'Todos os Responsáveis', label: 'Todos os Responsáveis' },
  { id: 'caroline', value: 'caroline', nome: 'Caroline Vit', label: 'Caroline Vit' },
  { id: 'eduardo', value: 'eduardo', nome: 'Eduardo Tuma', label: 'Eduardo Tuma' },
  { id: 'fabio', value: 'fabio', nome: 'Fábio Rossi', label: 'Fábio Rossi' }
];

// Lista estática para o status do e-mail
export const emailStatusOptions = [
    { value: 'Não verificado', label: 'Não verificado' },
    { value: 'Válido', label: 'Válido' },
    { value: 'Inválido', label: 'Inválido' },
];